import React, { useRef, useState } from "react";
import { egoQuestions } from "../data/egoQuestions";
import "./ego.css";

export default function EgoTest({ language = "tr", onFinish }) {
  const [index, setIndex] = useState(0);
  const [answers, setAnswers] = useState([]);

  // Katılımcının ilk soruyu gördüğü an = envantere başlama zamanı.
  const startedAtRef = useRef(Date.now());

  const q = egoQuestions[index];
  const total = egoQuestions.length;
  const progress = Math.round(((index + 1) / total) * 100);

  const handleAnswer = (value) => {
    const newArr = [...answers, { id: q.id, category: q.category, value }];
    setAnswers(newArr);

    if (index === total - 1) {
      const durationMs = Date.now() - startedAtRef.current;
      onFinish(newArr, durationMs);
    } else {
      setIndex(index + 1);
    }
  };

  return (
    <div className="ego-wrapper">
      <div className="ego-progress">
        <div className="ego-progress-bar" style={{ width: `${progress}%` }} />
      </div>

      <div className="ego-box">
        <h2 className="ego-question">
          {language === "tr" ? q.tr : q.en}
        </h2>

        <div className="ego-buttons">
          <button className="ego-btn accept" onClick={() => handleAnswer(1)}>
            {language === "tr" ? "Kabul" : "Accept"}
          </button>

          <button className="ego-btn reject" onClick={() => handleAnswer(0)}>
            {language === "tr" ? "Red" : "Reject"}
          </button>
        </div>

        <div className="ego-counter">{index + 1} / {total}</div>

        <p
          style={{
            marginTop: 14,
            marginBottom: 0,
            fontSize: 13,
            opacity: 0.7,
            textAlign: "center",
          }}
        >
          {language === "tr"
            ? "⏱ Yetişkinler genelde 6-7 dakikada tamamlar."
            : "⏱ Adults usually complete it in about 6–7 minutes."}
        </p>
      </div>
    </div>
  );
}
